import { AllowedPath, PathOption } from "../AdminBulkUpload";

export const getDisplayType = (path: AllowedPath | null): string => {
  switch (path) {
    case "Images":
      return "Images";
    case "Podcast":
      return "Podcast";
    case "Syndicated Videos":
      return "Videos";
    case "E-books (Learning Materials)":
    case "E-books (Question Bank)":
    case "E-books (Examination Guide)":
      return "Documents";
    default:
      return "Images, Videos, Documents and Audios";
  }
};


// Utility function for cleaner mapping
export const getFileType = (mimeType: string): string | null => {
  switch (mimeType) {
    case "application/pdf":
      return "pdf";
    case "text/csv":
      return "csv";
    case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      return "xlsx";
    case "application/vnd.ms-excel":
      return "xls";
    case "application/vnd.ms-powerpoint":
      return "ppt";
    case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
      return "pptx";
    case "application/epub+zip":
      return "epub";
    case "application/msword":
      return "doc";
    case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      return "docx";
    default:
      return null;
  }
};
